import { useEffect, useState } from "react";
import { Box, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { naturalSort } from "../../../utils/naturalSort";
import { submitUpdateEvent } from "../api";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import MaterialUiButton from "../../../components/Buttons/MaterialUiButton/MaterialUiButton"
import Paper from "@material-ui/core/Paper";
import SimpleSelect from "../../../components/Forms/FieldTypes/Select";
import SimpleTextField from "../../../components/Forms/FieldTypes/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
  },
  formArea: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    maxHeight: "43vh",
    overflow: "auto",
  },
  submit: {
    marginTop: theme.spacing(4),
  },
  select: {
    marginTop: theme.spacing(1),
    width: "90%",
  },
  input: {
    width: "90%",
  },
}));
function Update(props) {
  const {
    apiUrl,
    assetData,
    eventTypes,
    facilities,
    setModal,
    setState,
    state,
    token,
    userId,
  } = props;

  const classes = useStyles();
  const [updateEvent, setUpdateEvent] = useState({
    location: "",
    event: "",
    note: "",
    zone: "",
  });

  const [facilityOptions, setFacilityOptions] = useState([]);

  useEffect(() => {
    const facilityItems = [];

    Object.keys(facilities)
      .sort((a, b) => {
        if (facilities[a].name && facilities[b].name) {
          return facilities[a].name.localeCompare(facilities[b].name);
        }
        return -1;
      })
      .forEach((key) => {
        facilityItems.push({
          value: key,
          label: facilities[key].name,
        });
      });
    setFacilityOptions(facilityItems);
  }, [facilities]);

  const [zones, setZones] = useState([]);

  const setFacilityZones = async (facilityId) => {
    if (!facilityId) {
      setZones([]);
    } else {
      const results = await fetch(`${apiUrl}facilities/${facilityId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      }).then((res) => res.json());

      if (results.success && results.facility?.zones?.length > 0) {
        setZones(results.facility.zones);
      } else {
        setZones([]);
      }
    }
  };

  return (
    <Box className={classes.root}>
      <h4 style={{ textAlign: "left" }}>Update Event</h4>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Paper className={classes.formArea} elevation={0}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                submitUpdateEvent(
                  { apiUrl, token, facilities, userId, assetData },
                  updateEvent
                ).then((res) => {
                  if (res.error) {
                    setModal({
                      modalShow: true,
                      text: `Uh-oh! Something went wrong while updating asset event... ${res.error}`,
                      isError: true,
                    });
                  } else {
                    setModal({
                      modalShow: true,
                      text: `Event update success!`,
                      isError: false,
                    });

                    setState({
                      ...state,
                      assetData: {
                        ...state.assetData,
                        ...res.asset,
                        lastEvent: res.assetHistory.event,
                        propertiesMap: {
                          ...(state.assetData.propertiesMap || {}),
                          ...res.asset.propertiesMap,
                          note: res.assetHistory.propertiesMap.note,
                        },
                      },
                      histories: {
                        ...state.histories,
                        assetHistories: [res.assetHistory].concat(
                          state?.histories?.assetHistories || []
                        ),
                        count: state.histories.count + 1,
                      },
                    });
                  }
                });
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    className={classes.select}
                    id="facilityName"
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => {
                      setUpdateEvent({
                        ...updateEvent,
                        location: value || null,
                        zone: null,
                      });

                      setFacilityZones(value?.value || null);
                    }}
                    options={facilityOptions.sort((a, b) =>
                      naturalSort(a.label, b.label)
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Facility Name"
                        variant="standard"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SimpleSelect
                    required
                    id="event"
                    label={"Event"}
                    value={updateEvent.event}
                    variant={"standard"}
                    margin="dense"
                    classes={classes}
                    onChange={(e) => {
                      setUpdateEvent({
                        ...updateEvent,
                        event: e.target.value,
                      });
                    }}
                    options={eventTypes
                      .map((event) => {
                        return {
                          value: event,
                          label: event,
                        };
                      })
                      .sort((a, b) => naturalSort(a.label, b.label))}
                  />
                </Grid>
                {zones?.length > 0 ? (
                  <Grid item xs={12} sm={4}>
                    <SimpleSelect
                      label={"Zone"}
                      id="binLocation"
                      value={updateEvent.zone}
                      variant={"standard"}
                      margin="dense"
                      classes={classes}
                      onChange={(e) => {
                        setUpdateEvent({
                          ...updateEvent,
                          zone: e.target.value,
                        });
                      }}
                      options={zones
                        .map((zone) => {
                          return {
                            value: zone,
                            label: zone.name,
                          };
                        })
                        .sort((a, b) =>
                          naturalSort(a.label, b.label)
                        )}
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12} sm={4}>
                  <SimpleTextField
                    type={"text"}
                    id="binLocation"
                    className={classes.input}
                    variant={"standard"}
                    margin="dense"
                    label={"Bin Location"}
                    name={"binLocation"}
                    onChange={(e) => {
                      setUpdateEvent({
                        ...updateEvent,
                        binLocation: e.target.value,
                      });
                    }}
                    value={updateEvent.binLocation}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <SimpleTextField
                    id="note"
                    type={"text"}
                    className={classes.input}
                    variant={"standard"}
                    margin="normal"
                    multiline={true}
                    rows={"2"}
                    label={"Notes"}
                    name={"note"}
                    onChange={(e) => {
                      setUpdateEvent({
                        ...updateEvent,
                        note: e.target.value,
                      });
                    }}
                    value={updateEvent.note}
                  />
                </Grid>
              </Grid>
              <MaterialUiButton
                className={classes.submit}
                label="Submit"
                type="submit"
                variant="contained"
              />
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Update;
